import { render, staticRenderFns } from "./resource-zhenci-edit.vue?vue&type=template&id=76882740&scoped=true&"
import script from "./resource-zhenci-edit.vue?vue&type=script&lang=ts&"
export * from "./resource-zhenci-edit.vue?vue&type=script&lang=ts&"
import style0 from "./resource-zhenci-edit.vue?vue&type=style&index=0&id=76882740&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76882740",
  null
  
)

export default component.exports